var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-vue",attrs:{"role":"img","aria-hidden":!_vm.title,"aria-label":_vm.title},domProps:{"innerHTML":_vm._s(_vm.cleanSvg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }